import { useAuthStore } from '@/stores/auth.ts';
export class ExperimentsService {
    can(experimentType) {
        if (!this._companyCheck()) {
            return false;
        }
        const experiment = this._getExperiment(experimentType);
        return Boolean(experiment);
    }
    _companyCheck() {
        if (!this.getAuthStore().experiments) {
            return false;
        }
        return this.getAuthStore().experiments;
    }
    _getExperiment(type) {
        if (!this.getAuthStore().experiments[type]) {
            return false;
        }
        return this.getAuthStore().experiments[type];
    }
    getAuthStore() {
        return useAuthStore();
    }
}
export const experimentsService = new ExperimentsService();
